// extracted by mini-css-extract-plugin
export default {"header":"Convos_header__vkx-X","subheader":"Convos_subheader__Ia5Dd"};